<template>
  <div id="app_dashboard_admin">
    <v-container fluid>
      <v-card flat>
        <v-card-item>
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-card-title class="custom_page_main_title">COLLECTION DASHBOARD | PIYESTRA</v-card-title>
              <v-divider style="height: 50px !important;" vertical class="ml-4" thickness="2"></v-divider>
            </div>
            
            <div class="d-flex align-center">
              <v-menu
                v-model="fromMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="fromDateDisplay"
                    label="From Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                    variant="outlined"
                    density="comfortable"
                    style="width: 180px;"
                    class="custom-date-field"
                    hide-details
                    clearable
                    @click:clear="clearFromDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  @update:model-value="onFromDateSelect"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>

              <v-menu
                v-model="toMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="toDateDisplay"
                    label="To Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="props"
                    variant="outlined"
                    density="comfortable"
                    style="width: 180px; margin-left: 12px;"
                    class="custom-date-field"
                    hide-details
                    clearable
                    @click:clear="clearToDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  @update:model-value="onToDateSelect"
                  :max="maxDate"
                  :min="fromDate"
                ></v-date-picker>
              </v-menu>

              <v-btn
                v-if="fromDate || toDate"
                icon
                size="small"
                variant="outlined"
                @click="clearAllDates"
                class="ml-2"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-item>
        <v-divider thickness="2"></v-divider>
      </v-card>

      <v-row class="mt-6">
        <v-col cols="12" sm="6" md="4" lg="4" v-for="(card, index) in metricsCardsFirstRow" :key="index">
          <v-card class="metric-card" elevation="0" variant="outlined">
            <div class="metric-card-header">
              <span class="metric-title">{{ card.title }}</span>
              <v-icon class="metric-icon" size="28">{{ card.icon }}</v-icon>
            </div>
            <v-divider class="metric-divider"></v-divider>
            <div class="metric-card-body">
              <span class="metric-number">{{ formatNumber(card.value) }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4" v-for="(card, index) in metricsCardsSecondRow" :key="index">
          <v-card class="metric-card" elevation="0" variant="outlined">
            <div class="metric-card-header">
              <span class="metric-title">{{ card.title }}</span>
              <v-icon class="metric-icon" size="28">{{ card.icon }}</v-icon>
            </div>
            <v-divider class="metric-divider"></v-divider>
            <div class="metric-card-body">
              <span class="metric-number">{{ formatNumber(card.value) }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'ReportCard',
  
  data() {
    return {
      maxDate: new Date(),
      fromDate: null,
      toDate: null,
      fromMenu: false,
      toMenu: false,
      fromDateDisplay: '',
      toDateDisplay: '',
      activeDealerCount: 0,
    };
  },

  computed: {
    ...mapGetters({ 
      storeDashboard: 'getDashboardDetails' 
    }),
    
    dashboardData() {
      return this.storeDashboard?.rawData || this.storeDashboard || {};
    },

    allMetricsCards() {
      const d = this.dashboardData;
      return [
        {
          title: 'TOTAL RECEIPTS',
          value: d.totalReceiptCount || 0,
          icon: 'mdi-file-document-outline'
        },
        {
          title: 'TOTAL OVERDUE',
          value: d.totalOverdueCount || 0,
          icon: 'mdi-alert-circle-outline'
        },
        {
          title: 'TOTAL NEW VISITS',
          value: d.totalLeadCount || 0,
          icon: 'mdi-account-group-outline'
        },
        {
          title: 'TOTAL ROUTES',
          value: d.totalRouteCount || 0,
          icon: 'mdi-map-marker-path'
        },
        {
          title: 'ACTIVE DEALERS',
          value: this.activeDealerCount > 0 ? this.activeDealerCount : (d.totalActiveDealerCount || 0),
          icon: 'mdi-storefront-outline'
        },
        {
          title: 'DAILY SUMMARIES',
          value: d.totalDailySummaryCount || 0,
          icon: 'mdi-file-document-outline'
        },
      ];
    },

    metricsCardsFirstRow() {
      return this.allMetricsCards.slice(0, 3);
    },

    metricsCardsSecondRow() {
      return this.allMetricsCards.slice(3, 6);
    }
  },

  watch: {
    fromDate(newVal) {
      this.fromDateDisplay = newVal ? this.formatDateDisplay(newVal) : '';
      if (newVal && this.toDate) {
        this.emitDateFilter();
      } else if (!newVal && !this.toDate) {
        this.emitClearFilter();
      } else if (!newVal && this.toDate) {
        this.emitClearFilter();
      }
    },
    toDate(newVal) {
      this.toDateDisplay = newVal ? this.formatDateDisplay(newVal) : '';
      if (newVal && this.fromDate) {
        this.emitDateFilter();
      } else if (!newVal && !this.fromDate) {
        this.emitClearFilter();
      } else if (!newVal && this.fromDate) {
        this.emitClearFilter();
      }
    }
  },

  created() {
    this.fetchActiveDealers();
    this.initializeDefaultDates();
  },

  methods: {
    /**
     * Sets the default date range:
     * - To Date   = today
     * - From Date = one month before today
     */
    initializeDefaultDates() {
      const today = new Date();

      // To Date = today
      const to = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      // From Date = one month before today
      const from = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

      // Handle month-length edge cases (e.g. Mar 31 -> Feb 31 doesn't exist,
      // JS would normally roll it into March). If the day got shifted because
      // the target month is shorter, clamp to the last day of that month.
      if (from.getDate() !== today.getDate()) {
        from.setDate(0); // rolls back to the last day of the previous month
      }

      this.fromDate = from;
      this.toDate = to;
      this.fromDateDisplay = this.formatDateDisplay(from);
      this.toDateDisplay = this.formatDateDisplay(to);

      this.$nextTick(() => {
        this.emitDateFilter();
      });
    },

    fetchActiveDealers() {
      const token = localStorage.getItem("token");
      const baseUrl = process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_API_BASE_URL;
      const url = `${baseUrl}/api/getAllDealers`;

      axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.data && response.data.success) {
          const dealers = response.data.data || [];
          
          const uniqueDealers = new Set();
          dealers.forEach(d => {
            if (d.id) {
              uniqueDealers.add(d.id);
            }
          });
          
          this.activeDealerCount = uniqueDealers.size;
        }
      })
      .catch(error => {
        console.error('Error fetching dealers list:', error);
      });
    },

    onFromDateSelect(date) {
      this.fromDate = date;
      this.fromMenu = false;
      if (this.toDate && this.toDate < this.fromDate) {
        this.toDate = null;
        this.toDateDisplay = '';
      }
    },

    onToDateSelect(date) {
      this.toDate = date;
      this.toMenu = false;
    },

    clearFromDate() {
      this.fromDate = null;
      this.fromDateDisplay = '';
    },

    clearToDate() {
      this.toDate = null;
      this.toDateDisplay = '';
    },

    clearAllDates() {
      this.fromDate = null;
      this.toDate = null;
      this.fromDateDisplay = '';
      this.toDateDisplay = '';
      this.emitClearFilter();
    },

    emitDateFilter() {
      if (this.fromDate && this.toDate) {
        const formatDate = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };
        
        const startDate = formatDate(this.fromDate);
        const endDate = formatDate(this.toDate);
        
        console.log('📅 Auto-applying date filter:', { startDate, endDate });
        
        this.$emit('filterDateRange', {
          start: startDate,
          end: endDate
        });
      }
    },

    emitClearFilter() {
      console.log('🧹 Auto-clearing date filter');
      this.$emit('ClearfilterDateRange');
    },

    formatDateDisplay(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatNumber(num) {
      return new Intl.NumberFormat('en-US').format(num || 0);
    }
  }
}
</script>

<style scoped>
/* Custom fix for floating date labels being clipped at the top */
.custom-date-field {
  padding-top: 5px !important;
}

.custom-date-field :deep(.v-field--focused .v-label.v-field-label--floating),
.custom-date-field :deep(.v-field--dirty .v-label.v-field-label--floating) {
  top: 5px !important;
}

.metric-card {
  background-color: #ffffff !important;
  border: 1.5px solid #800080 !important;
  border-radius: 2px !important;
  padding: 20px 24px;
  height: 140px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

/* Subtle Purple Blur Effect */
.metric-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(128, 0, 128, 0.04);
  backdrop-filter: blur(2px);
  pointer-events: none;
  border-radius: 2px;
  z-index: 0;
}

.metric-card > * {
  position: relative;
  z-index: 1;
}

.metric-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(128, 0, 128, 0.15) !important;
}

.metric-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.metric-title {
  font-size: 0.8rem;
  font-weight: 600;
  color: #666666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-icon {
  color: #800080 !important;
  opacity: 0.7;
}

.metric-divider {
  border-color: #800080 !important;
  border-width: 1.5px !important;
  margin: 12px 0;
  opacity: 0.5;
}

.metric-card-body {
  display: flex;
  align-items: flex-end;
  flex: 1;
}

.metric-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #333333;
  line-height: 1;
}
</style>